<template>
  <v-app class="admin">
    <Sidebar
      v-if="showSidenav || $vuetify.breakpoint.lgAndUp"
      :links="links"
    />

    <button
      v-if="$vuetify.breakpoint.mdAndDown"
      class="default-btn blue circle"
      :class="{ open: showSidenav }"
      @click="showSidenav = !showSidenav"
    ><v-icon>mdi-reorder-horizontal</v-icon></button>

    <v-main :class="{
      open: showSidenav || $vuetify.breakpoint.lgAndUp
    }">
      <router-view></router-view>
    </v-main>

    <Footer :class="{
      open: $vuetify.breakpoint.lgAndUp
    }" />
  </v-app>
</template>

<script>
import Footer from '@/modules/shared/components/ui/Footer'
import Sidebar from '@/modules/shared/components/ui/SideNavbarAdmin'

export default {
  name: 'Layout',
  components: {
    Footer,
    Sidebar,
  },
  data: () => ({
    showSidenav: false,
    links: [
      {
        to: { name: 'AdminDashboard' },
        text: 'Dashboard',
        subtext: 'In Development',
      },
      {
        to: { name: 'AdminHubspot' },
        text: 'Hubspot',
      },
      {
        to: { name: 'AdminAds' },
        text: 'Ads',
      },
      {
        to: { name: 'AdminOrganizations' },
        text: 'Organizations',
      },
      {
        to: { name: 'AdminProducts' },
        text: 'Products',
      },
      {
        to: { name: 'AdminLeads' },
        text: 'Leads',
      },
      {
        to: { name: 'AdminUsers' },
        text: 'Users',
      },
      {
        to: { name: 'AdminProviders' },
        text: 'Providers',
      },
      {
        text: 'Questionnaire',
        children: [
          { text: 'Match Tester', to: { name: 'MatchTester' } },
        ],
      },
      {
        to: { name: 'AdminLogs' },
        text: 'Application Logs',
      },
    ],
  }),
}
</script>

<style lang="scss">
.v-application.admin {
  @import "../../../shared/assets//styles/admin.scss";
}
</style>

<style lang="scss" scoped>
.v-application {
  .default-btn.circle {
    position: fixed;
    top: 15px;
    left: 15px;
    z-index: 10;

    height: 40px;
    width: 40px;
    padding: 0;

    opacity: 0.6;

    &.open {
      left: 280px;
    }

    .v-icon {
      font-size: 24px;
    }
  }
}

</style>
